(function($) {
  var needRedirect = function() {
    var cookieName = "culturefly_checkout_redirect";
    var cookie = readCookie(cookieName);
    var redirectUrl = getUrlParameter("redirect_url");

    // Set cookie in case of the parameters is not avaliable later.
    if (cookie === null) {
      if (redirectUrl) {
        createCookie(cookieName, redirectUrl, 2);
      }
    }
    
    redirectLogic(cookie);
  };

  /**
   * Set redirect to the checkout if need it.
   * @return {[type]} [description]
   */
  var redirectLogic = function(whereToRedirectAfterRegistering) { 
          
    var loginForm = jQuery('form[action$="/account/login"][method="post"]');
    if (loginForm.length) {
      
      if (whereToRedirectAfterRegistering === null) {
		whereToRedirectAfterRegistering = document.referrer;
      }
      	
       var loginFormElement = $('input#redirect_url');
	   loginFormElement.attr("value", whereToRedirectAfterRegistering);
    }

  
    var registerForm = jQuery('form[action$="/account"][method="post"]');
    if (registerForm.length) {
        var formElement = $('<input type="hidden" name="return_to">');
	    formElement.attr("value", whereToRedirectAfterRegistering);
	    registerForm.append(formElement);
    }
  };

  /**
   * Get query parameter
   * @param  {[type]} sParam [description]
   * @return {[type]}        [description]
   */
  var getUrlParameter = function(sParam) {
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
      sURLVariables = sPageURL.split("&"),
      sParameterName,
      i;
    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split("=");
      if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined ? true : sParameterName[1];
      }
    }
  };

  /**
   * Creates cookie
   * @param  {[type]} name  [description]
   * @param  {[type]} value [description]
   * @param  {[type]} days  [description]
   * @return {[type]}       [description]
   */
  var createCookie = function(name, value, days) {
    var expires;
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toGMTString();
    } else {
      expires = "";
    }
    document.cookie =
      encodeURIComponent(name) +
      "=" +
      window.btoa(value) +
      expires +
      "; path=/";
  };

  /**
   * Read's Cookie by name
   * @param  {[type]} name [description]
   * @return {[type]}      [description]
   */
  var readCookie = function(name) {
    var nameEQ = encodeURIComponent(name) + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0)
        return window.atob(c.substring(nameEQ.length, c.length));
    }
    return null;
  };

  /**
   * Deletes a cookie by name.
   * @param  {[type]} name [description]
   * @return {[type]}      [description]
   */
  var eraseCookie = function(name) {
    createCookie(name, "", -1);
  };
  
  setTimeout(function(){ needRedirect();
 }, 500);


})(jQuery);
